import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';

function ExploreExhibitions() {
    return (
        <div id="wrapper">

            {/* Header component */}
            <Header />

            <div class="no-bottom no-top" id="content">
                <div id="top"></div>

                <section id="subheader" class="minimal">
                    <div class="center-y relative text-center">
                        <div class="container">
                            <div class="row">

                                <div class="col-md-12 text-center">
                                    <h1>Exhibitions</h1>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="section-news">
                    <div class="container" >
                        <div class="row wow fadeIn animated">
                            <div class="col-lg-4 col-md-6 mb-sm-30">
                                <div class="bloglist item">
                                    <div class="post-content">
                                        <div class="post-image">
                                            <img alt="" src="https://f8n-production.imgix.net/worlds/zkeny1rmr.jpg?q=70&cs=srgb&max-w=720&max-h=720&fit=fill&dpr=2&fnd_key=v1" class="lazy" />
                                        </div>
                                        <div class="post-text">
                                            <span class="p-date">October 28, 2020</span>
                                            <h4><a href="/single?id=sequence-kx">SEQUENCE by KX<span></span></a></h4>
                                            <p> Kx__
                                                <br />Presented by Suburbs Gallery Highlights
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 mb-sm-30">
                                <div class="bloglist item">
                                    <div class="post-content">
                                        <div class="post-image">
                                            <img alt="" src="https://f8n-production.imgix.net/worlds/t2c1k0rfu.jpg?q=70&cs=srgb&max-w=720&max-h=720&fit=fill&dpr=2&fnd_key=v1" class="lazy" />
                                        </div>
                                        <div class="post-text">
                                            <span class="p-date">October 28, 2020</span>
                                            <h4><a href="/single?id=deconstructed">DECONSTRUCTED<span></span></a></h4>
                                            <p> blanq, Jess Mac, and 14 others<br />
                                                Presented by MAIF</p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </section>

            </div>



            {/* Footer */}
            <Footer />


        </div>
    );
}

export default ExploreExhibitions;